module.exports = __webpack_public_path__ + "img/w2-cover.f20ceabd.jpg";